// Import Angular modules
import { Component, Input, Output, EventEmitter, HostListener, OnChanges, ChangeDetectorRef } from '@angular/core';


/*
* @Component: ConichiSelectComponent
*
* Components are the main way we build and specify elements and logic on the page, through both
* custom elements and attributes that add functionality to our existing components.
* 
* This component is used to build Conichi Material Select component.
*/

@Component({
  selector: 'conichi-select',
  templateUrl: './select.html'
})

export class ConichiSelectComponent implements OnChanges {
  public openDropdown: boolean;
  public displayValue: any;
  public selection: string;

  @Output() modelChange = new EventEmitter();
  @Input() placeholder: string;
  @Input() options: Array<any>;
  @Input() keys: string;
  @Input() model: string;

  @HostListener('document:click', ['$event']) clickedOutside($event) {
    this.openDropdown = false;
  }

  constructor(private cd: ChangeDetectorRef) {}

  ngOnChanges(changes) {
    if (!this.keys) this.keys = 'label, value';
    if (this.options) this.assignKeys();
    if (this.model && this.options) this.select(this.options.find((option) => option.value === this.model));
    
    if (this.selection && changes.options && changes.options.currentValue) {
      const selection = changes.options.currentValue.find((option) => option.value === this.selection);
      this.displayValue = selection.label;
      this.selection = selection.value;
    }

    this.cd.detectChanges();
  }

  focusInput($event) {
    this.openDropdown = true;
    $event.preventDefault();
    $event.stopPropagation();
  }

  assignKeys() {
    const keys = this.keys.replace(/\s/g, '').split(',');

    this.options.forEach((option) => {
      if (!option['label']) { option['label'] = option[keys[0]]; delete option[keys[0]]; }
      if (!option['value']) { option['value'] = option[keys[1]]; delete option[keys[1]]; }
    });
  }

  select(option) {
    this.displayValue = option.label;
    this.model = option.value;
    this.selection = option.value;
    this.openDropdown = false;
    this.modelChange.emit(this.model);
    this.cd.detectChanges();
  }
}
